import { lazy } from "react";

import { RoutePathBuilder } from "@/common/builders/routePath";
import AuthorizedRoute from "@/common/components/Auth/AuthorizedRoute";
import { Loadable } from "@/common/components/Loadable";
import { ROUTE_PATH } from "@/common/constants/routing";
import { AppPermission } from "@/core/api/generated/v1";

const RepairSparePartCreateUpdatePage = Loadable(
  lazy(() => import("../../MainAppView/Repair/RepairSparePart/RepairSparePartCreateUpdatePage")),
);
const RepairSparePartViewPage = Loadable(
  lazy(() => import("../../MainAppView/Repair/RepairSparePart/RepairSparePartViewPage")),
);
const RepairSparePartsPage = Loadable(
  lazy(() => import("../../MainAppView/Repair/RepairSparePart/RepairSparePartsPage")),
);
const RepairMaterialCreateUpdatePage = Loadable(
  lazy(() => import("../../MainAppView/Repair/RepairMaterial/RepairMaterialCreateUpdatePage")),
);
const RepairMaterialViewPage = Loadable(
  lazy(() => import("../../MainAppView/Repair/RepairMaterial/RepairMaterialViewPage")),
);
const RepairMaterialsPage = Loadable(
  lazy(() => import("../../MainAppView/Repair/RepairMaterial/RepairMaterialsPage")),
);
const RepairSpecCreateUpdatePage = Loadable(
  lazy(() => import("../../MainAppView/Repair/RepairSpec/RepairSpecCreateUpdatePage")),
);
const RepairSpecViewPage = Loadable(
  lazy(() => import("../../MainAppView/Repair/RepairSpec/RepairSpecViewPage")),
);
const RepairSpecsPage = Loadable(
  lazy(() => import("../../MainAppView/Repair/RepairSpec/RepairSpecsPage")),
);
const RepairWorkCreateUpdatePage = Loadable(
  lazy(() => import("../../MainAppView/Repair/RepairWork/RepairWorkCreateUpdatePage")),
);
const RepairWorkListPage = Loadable(
  lazy(() => import("../../MainAppView/Repair/RepairWork/RepairWorkListPage")),
);
const RepairWorkViewPage = Loadable(
  lazy(() => import("../../MainAppView/Repair/RepairWork/RepairWorkViewPage")),
);

export function RepairRoutes() {
  return (
    <>
      {/* RepairMaterial */}
      <AuthorizedRoute
        permissions={[AppPermission.RepairCatalogRead, AppPermission.FleetAppAccess]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.REPAIR_MATERIALS)}
        render={() => <RepairMaterialsPage />}
      />
      <AuthorizedRoute
        permissions={[AppPermission.RepairCatalogManage, AppPermission.FleetAppAccess]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.REPAIR_MATERIAL_CREATE)}
        render={() => <RepairMaterialCreateUpdatePage />}
      />
      <AuthorizedRoute
        permissions={[AppPermission.RepairCatalogManage, AppPermission.FleetAppAccess]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.REPAIR_MATERIAL_EDIT())}
        render={() => <RepairMaterialCreateUpdatePage />}
      />
      <AuthorizedRoute
        permissions={[AppPermission.RepairCatalogRead, AppPermission.FleetAppAccess]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.REPAIR_MATERIAL_VIEW())}
        render={() => <RepairMaterialViewPage />}
      />

      {/* RepairWork */}
      <AuthorizedRoute
        permissions={[AppPermission.RepairCatalogRead, AppPermission.FleetAppAccess]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.REPAIR_WORK_LIST)}
        render={() => <RepairWorkListPage />}
      />
      <AuthorizedRoute
        permissions={[AppPermission.RepairCatalogManage, AppPermission.FleetAppAccess]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.REPAIR_WORK_CREATE)}
        render={() => <RepairWorkCreateUpdatePage />}
      />
      <AuthorizedRoute
        permissions={[AppPermission.RepairCatalogManage, AppPermission.FleetAppAccess]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.REPAIR_WORK_EDIT())}
        render={() => <RepairWorkCreateUpdatePage />}
      />
      <AuthorizedRoute
        permissions={[AppPermission.RepairCatalogRead, AppPermission.FleetAppAccess]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.REPAIR_WORK_VIEW())}
        render={() => <RepairWorkViewPage />}
      />

      {/* RepairSparePart */}
      <AuthorizedRoute
        permissions={[AppPermission.RepairCatalogRead, AppPermission.FleetAppAccess]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.REPAIR_SPARE_PARTS)}
        render={() => <RepairSparePartsPage />}
      />
      <AuthorizedRoute
        permissions={[AppPermission.RepairCatalogManage, AppPermission.FleetAppAccess]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.REPAIR_SPARE_PART_CREATE)}
        render={() => <RepairSparePartCreateUpdatePage />}
      />
      <AuthorizedRoute
        permissions={[AppPermission.RepairCatalogManage, AppPermission.FleetAppAccess]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.REPAIR_SPARE_PART_EDIT())}
        render={() => <RepairSparePartCreateUpdatePage />}
      />
      <AuthorizedRoute
        permissions={[AppPermission.RepairCatalogRead, AppPermission.FleetAppAccess]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.REPAIR_SPARE_PART_VIEW())}
        render={() => <RepairSparePartViewPage />}
      />

      {/* RepairSpec */}
      <AuthorizedRoute
        permissions={[AppPermission.RepairCatalogRead, AppPermission.FleetAppAccess]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.REPAIR_SPECS)}
        render={() => <RepairSpecsPage />}
      />
      <AuthorizedRoute
        permissions={[AppPermission.RepairCatalogRead, AppPermission.FleetAppAccess]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.REPAIR_SPEC_VIEW())}
        render={() => <RepairSpecViewPage />}
      />
      <AuthorizedRoute
        permissions={[AppPermission.RepairCatalogManage, AppPermission.FleetAppAccess]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.REPAIR_SPEC_CREATE)}
        render={() => <RepairSpecCreateUpdatePage />}
      />
      <AuthorizedRoute
        permissions={[AppPermission.RepairCatalogManage, AppPermission.FleetAppAccess]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.REPAIR_SPEC_EDIT())}
        render={() => <RepairSpecCreateUpdatePage />}
      />
    </>
  );
}
